import { connect, Summary } from '../dependencies';
import { expenseSummarySelector } from '../services/selectors';

const mapStateToProps = (state, { expenseId }) => {
    return expenseSummarySelector(state, expenseId);
};

export default connect(mapStateToProps)(Summary);
